import { defineMessages } from 'react-intl';

export const blogMessages = defineMessages({
  missDiorText: {
    id: 'pd.blog.missDiorText',
    defaultMessage: 'Vůně Miss Dior byla znovuobjevena v nové tuhé podobě.',
  },
  diorJadoreText: {
    id: 'pd.blog.jadoreText',
    defaultMessage:
      'Znovu objevte parfémovanou vodu J´adore a harmonii pocitů, které vytvářejí dojem vysněné květiny.',
  },
  diorHommeText: {
    id: 'pd.blog.diorHommeText',
    defaultMessage:
      'Nová interpretace parfému Dior Homme je příběhem vyprávějícím o setkání.',
  },
  diorForeverText: {
    id: 'pd.blog.diorForeverText',
    defaultMessage:
      'Zažijte vlnu svěžesti na vlastí pleti díky novému Dior Forever Hydra Nude.',
  },
});
